(() => {
  const init = () => {
    document.querySelectorAll('[data-ns-recipes]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-ns-card]')];
      const search = root.querySelector('[data-ns-search]');
      const region = root.querySelector('[data-ns-region]');
      const product = root.querySelector('[data-ns-product]');
      const filters = [...root.querySelectorAll('[data-ns-diet]')];
      const count = root.querySelector('[data-ns-count]');
      const empty = root.querySelector('[data-ns-empty]');
      let diet = 'all';
      const filter = () => {
        const query = search.value.toLocaleLowerCase().trim();
        let total = 0;
        cards.forEach(card => {
          const used = (card.dataset.products || '').split(' ');
          const selected = product ? product.value : 'all';
          const paste = used.some(key => ['ginger_garlic', 'ginger', 'garlic_paste'].includes(key));
          const productMatch = selected === 'all' ||
            (selected === 'onions_only' ? used.length === 1 && used.includes('onions') :
              selected === 'paste_onions' ? paste && used.includes('onions') : used.includes(selected));
          const match = (diet === 'all' || card.dataset.diet === diet) &&
            productMatch &&
            (region.value === 'all' || card.dataset.region === region.value) &&
            (!query || card.dataset.search.toLocaleLowerCase().includes(query));
          card.hidden = !match;
          if (match) total++;
        });
        count.textContent = total === 1 ? root.dataset.countSingular : root.dataset.countTemplate.replace('COUNT_TOKEN', total);
        empty.hidden = total !== 0;
      };
      filters.forEach(button => button.addEventListener('click', () => {
        diet = button.dataset.nsDiet;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        filter();
      }));
      search.addEventListener('input', filter);
      region.addEventListener('change', filter);
      if (product) product.addEventListener('change', filter);
      const dialogs = [...root.querySelectorAll('dialog')];
      let trigger = null;
      const open = dialog => {
        if (!dialog || dialog.open) return;
        dialogs.forEach(item => { if (item.open) item.close(); });
        dialog.showModal();
        document.documentElement.classList.add('ns-modal-open');
        history.replaceState(null, '', '#' + dialog.id);
      };
      root.querySelectorAll('[data-ns-open]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        open(document.getElementById(button.dataset.nsOpen));
      }));
      dialogs.forEach(dialog => {
        dialog.querySelectorAll('[data-nlv2-route]').forEach(link => link.addEventListener('click', () => dialog.close()));
        dialog.querySelector('[data-ns-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('ns-modal-open');
          if (location.hash === '#' + dialog.id) history.replaceState(null, '', location.pathname + location.search);
          if (trigger) trigger.focus({preventScroll:true});
        });
      });
      const fromHash = () => {
        const id = location.hash.slice(1);
        const dialog = dialogs.find(item => item.id === id);
        if (dialog) open(dialog);
      };
      window.addEventListener('hashchange', fromHash);
      filter();
      fromHash();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
